import { gql } from '@apollo/client';

// GraphQL mutation for getting a presigned URL
export const GET_PRESIGNED_URL = gql`
    mutation GetPresignedUrl($fileType: String!, $fileSize: Int!) {
        getPresignedUrl(input: { fileType: $fileType, fileSize: $fileSize }) {
            presignedUrl
            key
            imageUrl
        }
    }
`;
